// extracted by mini-css-extract-plugin
export default {"error-wrapper":"Error_error-wrapper__rp41R","info":"Error_info__jjwMQ"};